import React from 'react'
import style from './Switch.module.css'

export interface CheckboxProps {
  isChecked: boolean
  classname?: string
  onChange: (value: boolean) => void
}

export function Switch({ onChange, isChecked, classname }: CheckboxProps) {
  const handleChange = () => onChange(!isChecked)
  return (
    <label className={[style.switch, classname].join(' ')}>
      <input type='checkbox' onChange={handleChange} checked={isChecked} />
      <span className={style.slider}></span>
    </label>
  )
}
